<div class="add-card-container">
  <div class="header">
    <button class="back-btn" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      <span>Back</span>
    </button>
    <h1 class="page-title">Add Debit Card</h1>
  </div>

  <div class="content">
    <div class="info-card">
      <div class="info-icon">
        <i class="pi pi-info-circle"></i>
      </div>
      <p class="info-text">
        A ₦100 charge will be made to verify your card. This amount may be refunded.
      </p>
    </div>

    <div class="action-section">
      <button 
        class="add-card-btn" 
        (click)="addCard()" 
        [disabled]="isLoading()">
        @if (isLoading()) {
          <p-progressSpinner 
            styleClass="spinner-small" 
            strokeWidth="3">
          </p-progressSpinner>
          <span>Processing...</span>
        } @else {
          <i class="pi pi-plus"></i>
          <span>Add New Card</span>
        }
      </button>
    </div>
  </div>
</div>

<p-toast></p-toast>
